import React, { Component } from "react";
import ShowCodeButton from "./ShowCodeButton";

class Step extends Component {
  state = {
    showCode: false
  };

  showCodeChange = () => {
    this.setState({
      showCode: !this.state.showCode
    });
  };

  render() {
    if (!this.state.showCode) {
      return (
        <div>
          {this.props.explanation}
          {this.props.code === null ? null : (
            <ShowCodeButton
              showCode={this.state.showCode}
              showCodeChange={this.showCodeChange}
            />
          )}
        </div>
      );
    } else {
      return (
        <div>
          {this.props.code}
          <ShowCodeButton
            showCode={this.state.showCode}
            showCodeChange={this.showCodeChange}
          />
        </div>
      );
    }
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/steps/Step.js